<template>
    <div class="flex flex-row items-center">
      <span class="text-sm text_color">
        {{ localTime }}
      </span>
    </div>
  </template>
  
  <script setup>
  import { computed, onMounted, onUnmounted, ref } from "vue";
  
  const props = defineProps({
    timezone: { type: String, default: "" },
  });
  
  const currentTime = ref(new Date());
  let intervalId = null;
  
  const localTime = computed(() => {
    if (!props.timezone) return "--";
    
    try {
      const timezoneMatch = props.timezone.match(/^([^(]+)/);
      const cleanTimezone = timezoneMatch ? timezoneMatch[1].trim() : props.timezone;
      
      const options = {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZone: cleanTimezone,
      };
      
      return currentTime.value.toLocaleTimeString("en-US", options);
    } catch (error) {
      console.error("Error formatting local time:", error);
      return "--";
    }
  });
  
  onMounted(() => {
    intervalId = setInterval(() => {
      currentTime.value = new Date();
    }, 60000);
  });
  
  onUnmounted(() => {
    if (intervalId) {
      clearInterval(intervalId);
    }
  });
  </script>